export default __webpack_public_path__ + "static/media/icon_price.12fe1530.svg";